import { render, staticRenderFns } from "./CommonItem.vue?vue&type=template&id=e8962f40&scoped=true&"
import script from "./CommonItem.vue?vue&type=script&lang=js&"
export * from "./CommonItem.vue?vue&type=script&lang=js&"
import style0 from "./CommonItem.vue?vue&type=style&index=0&id=e8962f40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8962f40",
  null
  
)

export default component.exports